import config from 'constants/config'
import { agentHubOrSubBrandConfig } from 'agentHub/constants'
import { OIDC_CALLBACK_PATH } from 'lib/routing/regionlessPageRoutes'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

export const LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP = `/${agentHubOrSubBrandConfig.basePath}/complete-account-setup`
export const LE_AGENT_HUB_SOCIETE_CONFIRMATION = `/${agentHubOrSubBrandConfig.basePath}/societe-confirmation`

// The region-prefixed variant covers a region redirect rewriting the path first.
const LE_AGENT_HUB_OIDC_CALLBACK_PATHS = [OIDC_CALLBACK_PATH, `/:regionCode${OIDC_CALLBACK_PATH}`]

export function isAgentHubOidcCallbackPath(pathname: string): boolean {
  return config.agentHub.isEnabled &&
    !!matchLocaleAwarePath(pathname, { exact: true, path: LE_AGENT_HUB_OIDC_CALLBACK_PATHS })
}
